<template>
  <div class="waybill-list-page">
    <section class="filter-card">
      <el-form :model="query" size="small" class="filter-form" @submit.native.prevent>
        <el-form-item v-for="field in textFilters" :key="field.key" :label="field.label">
          <el-input v-model.trim="query[field.key]" clearable :placeholder="'请输入' + field.label" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="运输状态">
          <el-select v-model="query.status" clearable placeholder="全部"><el-option v-for="item in statuses" :key="item.value" :label="item.label" :value="item.value" /><el-option v-if="hasInactiveStatus" :label="statusText(query.status)" :value="query.status" disabled /></el-select>
        </el-form-item>
        <el-form-item class="filter-form__time">
          <div class="filter-time-range">
            <el-select v-model="query.timeField" class="filter-time-range__type"><el-option v-for="item in timeFields" :key="item.value" :label="item.label" :value="item.value" /></el-select>
            <el-date-picker v-model="query.timeRange" type="datetimerange" value-format="timestamp" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']" />
          </div>
        </el-form-item>
        <el-form-item v-if="!embedMode" label="告警类型">
          <el-select v-model="query.alarmType" clearable placeholder="全部"><el-option v-for="item in alarmOptions" :key="item.value" :label="item.label" :value="item.value" /></el-select>
        </el-form-item>
        <div class="filter-actions"><el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button><el-button size="small" @click="reset">重置</el-button></div>
      </el-form>
    </section>

    <section class="list-card">
      <div class="list-toolbar">
        <div class="list-toolbar__left">
          <template v-if="!embedMode">
            <el-button v-permission="'waybill:add'" type="primary" icon="el-icon-plus" @click="goCreate">新增</el-button>
            <el-button v-permission="'waybill:import'" icon="el-icon-upload2" @click="importVisible = true">导入</el-button>
            <el-button v-permission="'waybill:import'" @click="showRecords('IMPORT')">导入记录</el-button>
            <el-button v-permission="'waybill:export'" icon="el-icon-download" :loading="exporting" @click="exportList">导出</el-button>
            <el-button v-permission="'waybill:export'" @click="showRecords('EXPORT')">导出记录</el-button>
            <el-button v-permission="'waybill:edit'" @click="planSelectedRoute">路线规划</el-button>
          </template>
          <el-button v-permission="'waybill:status'" v-if="!embedMode || canAction" @click="selectedAction('start')">运输开始</el-button>
          <el-button v-permission="'waybill:status'" v-if="!embedMode || canAction" @click="selectedAction('finish')">运输完成</el-button>
          <el-button v-permission="'waybill:monitor'" @click="mergeTracks">合并轨迹</el-button>
          <el-button v-permission="'waybill:edit'" v-if="!embedMode" @click="changeAddress">更换地址</el-button>
          <el-button v-permission="'waybill:share'" v-if="!embedMode" @click="accountShareVisible = true">账号共享</el-button>
        </div>
        <div class="list-toolbar__right">
          <el-button icon="el-icon-refresh" title="刷新" :loading="loading" @click="fetchList" />
          <el-popover v-if="!embedMode" placement="bottom-end" width="250" trigger="click">
            <div class="list-settings"><strong>列表与地图设置</strong><el-checkbox v-model="preferences.hideCanceled" @change="savePreferences">隐藏作废单据</el-checkbox><el-checkbox v-model="preferences.hideMapVehicles" @change="savePreferences">全图可视不显示车辆图标</el-checkbox></div>
            <el-button slot="reference" icon="el-icon-setting" title="设置" />
          </el-popover>
        </div>
      </div>
      <div class="list-summary">
        <span>运输中 <strong>{{ stats.inTransit }}</strong> 单</span>
        <template v-if="!embedMode"><span>晚发 <strong class="summary-warning">{{ stats.lateDepart }}</strong> 单</span><span>晚到 <strong class="summary-danger">{{ stats.lateArrive }}</strong> 单</span></template>
        <span v-if="selected.length" class="selection-summary">已选 {{ selected.length }} 条<el-button type="text" size="mini" @click="clearSelection">取消选择</el-button></span>
        <span class="summary-total">共 {{ total }} 条运单</span>
      </div>
      <el-table ref="waybillTable" v-loading="loading" :data="items" border size="small" class="waybill-table" :default-sort="{ prop: sortField, order: sortOrder }" @selection-change="selected = $event" @sort-change="handleSortChange" @row-dblclick="openDetail">
        <el-table-column type="selection" width="44" fixed="left" align="center" />
        <el-table-column label="操作" width="252" fixed="left" align="center" class-name="waybill-actions">
          <template slot-scope="{ row }">
            <el-button v-permission="'waybill:monitor'" type="text" size="small" @click.stop="openMap(row, 'track')">轨迹</el-button>
            <el-button v-permission="'waybill:monitor'" type="text" size="small" @click.stop="openMap(row, 'position')">位置</el-button>
            <el-button v-permission="'waybill:share'" v-if="!embedMode" type="text" size="small" @click.stop="openShare(row)">分享</el-button>
            <el-button v-permission="'waybill:edit'" v-if="!embedMode && Number(row.transportStatus) === 0" type="text" size="small" @click.stop="edit(row)">编辑</el-button>
            <el-dropdown v-permission="['waybill:monitor', 'fullmap:view', 'waybill:status', 'waybill:delete']" trigger="click" @command="command => handleCommand(command, row)">
              <span class="more-action" @click.stop>更多<i class="el-icon-arrow-down" /></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-permission="['waybill:monitor', 'fullmap:view']" command="detail">运单详情</el-dropdown-item>
                <template v-if="!embedMode || canAction">
                  <el-dropdown-item v-permission="'waybill:status'" command="start" :disabled="Number(row.transportStatus) !== 0">开始运输</el-dropdown-item>
                  <el-dropdown-item v-permission="'waybill:status'" command="finish" :disabled="![1, 4].includes(Number(row.transportStatus))">完成运输</el-dropdown-item>
                </template>
                <el-dropdown-item v-if="!embedMode" v-permission="'waybill:status'" command="cancel" :disabled="![0, 1].includes(Number(row.transportStatus))" divided>作废运单</el-dropdown-item>
                <el-dropdown-item v-if="!embedMode" v-permission="'waybill:delete'" command="delete" :disabled="Number(row.transportStatus) !== 0">删除运单</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="waybillNo" label="运单号" width="185" fixed="left" show-overflow-tooltip />
        <el-table-column prop="vehicleNo" label="车牌号" width="120" align="center" />
        <el-table-column label="运输状态" width="120" align="center"><template slot-scope="{ row }"><el-tag :type="statusTag(row.transportStatus)" size="mini">{{ statusText(row.transportStatus) }}</el-tag></template></el-table-column>
        <el-table-column label="规划总里程" width="120" align="right"><template slot-scope="{ row }">{{ formatDistance(row.totalMileage) }}</template></el-table-column>
        <el-table-column label="剩余里程" width="120" align="right"><template slot-scope="{ row }">{{ formatDistance(row.remainingMileage) }}</template></el-table-column>
        <el-table-column label="运输进度" width="126" align="center"><template slot-scope="{ row }"><template v-if="progress(row) !== null"><el-progress :percentage="progress(row)" :stroke-width="5" :show-text="false" /><span class="progress-value">{{ progress(row) }}%</span></template><span v-else>-</span></template></el-table-column>
        <el-table-column v-if="!embedMode" label="告警" min-width="150" show-overflow-tooltip><template slot-scope="{ row }"><span :class="{ 'alarm-text': (row.alarmTypes || []).length }">{{ alarmText(row) }}</span></template></el-table-column>
        <el-table-column prop="startAddress" label="起始地" min-width="230" show-overflow-tooltip />
        <el-table-column prop="endAddress" label="目的地" min-width="230" show-overflow-tooltip />
        <el-table-column v-for="column in dateColumns" :key="column.key" :prop="column.key" :label="column.label" width="172" align="center" :sortable="column.sortable ? 'custom' : false"><template slot-scope="{ row }">{{ formatDate(row[column.key]) }}</template></el-table-column>
        <el-table-column prop="driverName" label="司机" width="105" show-overflow-tooltip />
        <el-table-column prop="driverPhone" label="手机号" width="135" />
        <el-table-column prop="cargoName" label="货物" min-width="150" show-overflow-tooltip />
        <el-table-column label="监控状态" width="105"><template slot-scope="{ row }">{{ monitorText(row) }}</template></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="172" align="center" sortable="custom"><template slot-scope="{ row }">{{ formatDate(row.createTime) }}</template></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="190" show-overflow-tooltip />
        <el-table-column prop="creatorName" label="创建人" width="110" />
      </el-table>
      <div class="pagination-wrap"><el-pagination :current-page="page" :page-size="pageSize" :page-sizes="[10, 15, 20, 50, 100]" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="changePageSize" @current-change="changePage" /></div>
    </section>

    <el-dialog title="作废运单" :visible.sync="cancelVisible" width="500px" :close-on-click-modal="false" :show-close="!canceling" :close-on-press-escape="!canceling">
      <el-alert title="作废后停止监控，已有轨迹和告警记录保留。" type="warning" :closable="false" show-icon />
      <el-form label-width="90px" style="margin-top: 18px">
        <el-form-item label="运单号">{{ cancelTarget && cancelTarget.waybillNo }}</el-form-item>
        <el-form-item label="作废原因"><el-input v-model="cancelReason" type="textarea" :rows="4" maxlength="256" show-word-limit placeholder="选填，最多256字" :disabled="canceling" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button :disabled="canceling" @click="cancelVisible = false">取消</el-button><el-button v-permission="'waybill:status'" type="danger" :loading="canceling" @click="submitCancel">确认作废</el-button></span>
    </el-dialog>
    <el-dialog title="导入运单" :visible.sync="importVisible" width="540px" append-to-body :close-on-click-modal="false" @closed="resetImport">
      <el-upload ref="waybillImportUpload" action="#" accept=".xlsx,.xls" :auto-upload="false" :limit="1" :file-list="importFileList" :on-change="onImportFileChange" :on-remove="resetImport" :on-exceed="onImportFileExceed">
        <el-button size="small" type="primary" icon="el-icon-upload2">选择文件</el-button><div slot="tip" class="el-upload__tip">支持 .xlsx、.xls，单次最多1000条。上传文件和处理结果可在导入记录中查看。</div>
      </el-upload>
      <p class="el-upload__tip">规划线路可从模板下拉选择，选项来自当前账号正常线路；线路变更后请重新下载模板。</p>
      <el-button v-permission="'waybill:import'" type="text" icon="el-icon-download" @click="downloadImportTemplate">下载导入模板</el-button>
      <div v-if="importResult" class="waybill-import-result">
        <el-alert :title="'导入完成：成功 ' + (importResult.successCount || 0) + ' 条，失败 ' + (importResult.failureCount || 0) + ' 条'" :type="Number(importResult.failureCount) ? 'warning' : 'success'" :closable="false" show-icon />
        <div v-if="importResult.errors && importResult.errors.length" class="waybill-import-errors"><div v-for="(error, index) in importResult.errors" :key="index">{{ typeof error === 'string' ? error : error.message }}</div></div>
      </div>
      <span slot="footer"><el-button @click="importVisible = false">关闭</el-button><el-button v-permission="'waybill:import'" type="primary" :loading="importing" :disabled="!!importResult" @click="submitImport">提交</el-button></span>
    </el-dialog>
    <el-dialog title="分享运单" :visible.sync="shareVisible" width="520px" append-to-body :close-on-click-modal="false">
      <el-form label-width="90px" size="small">
        <el-form-item label="运单号">{{ selectedRow.waybillNo }}</el-form-item>
        <el-form-item label="查看范围"><el-radio-group v-model="shareScope" :disabled="!!shareLink"><el-radio label="CURRENT_POSITION">当前位置</el-radio><el-radio label="FULL_TRIP">完整行程</el-radio></el-radio-group></el-form-item>
        <el-form-item label="有效期"><el-select v-model="shareHours" :disabled="!!shareLink"><el-option label="1小时" :value="1" /><el-option label="24小时" :value="24" /><el-option label="7天" :value="168" /></el-select></el-form-item>
        <el-form-item v-if="shareLink" label="分享链接"><el-input :value="shareLink" readonly /><el-button type="text" @click="copyShareLink">复制链接</el-button><el-button v-permission="'waybill:share'" type="text" :loading="sharing" @click="revokeShareLink">撤销此链接</el-button></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="shareVisible = false">关闭</el-button><el-button v-if="!shareLink" v-permission="'waybill:share'" type="primary" :loading="sharing" @click="createShareLink">生成链接</el-button></span>
    </el-dialog>
    <template v-if="!embedMode">
      <waybill-file-records :visible.sync="recordsVisible" :type="recordsType" />
      <waybill-address-change :visible.sync="addressVisible" :row="selectedRow" @success="fetchList" />
      <waybill-account-share :visible.sync="accountShareVisible" :waybills="selected" />
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { defaultBusinessOptions, loadBusinessOptions, businessOptionLabel } from '@/utils/businessDictionaries'
import { cancelWaybill, changeWaybillStatus, createWaybillShare, revokeWaybillShare, deleteWaybill, downloadWaybillImportTemplate, exportWaybillList, getWaybillList, queryWaybillList, importWaybills, isRequestSuccess } from './lingdongApi'
import WaybillFileRecords from './WaybillFileRecords.vue'
import WaybillAddressChange from './WaybillAddressChange.vue'
import WaybillAccountShare from './WaybillAccountShare.vue'
import { downloadWaybillBlob } from './waybillDownload'
import { loadWaybillPreferences, saveWaybillPreferences } from './waybillPreferences'
import { hasPermission } from '@/utils/auth'
const { createListQuery, buildListParams, filterEmbedWaybills, parseListState } = require('./waybillListQuery')
const cloneQuery = query => ({ ...query, timeRange: (query.timeRange || []).slice() })

export default {
  name: 'InTransit',
  components: { WaybillFileRecords, WaybillAddressChange, WaybillAccountShare },
  props: {
    embedMode: { type: Boolean, default: false },
    actionScopes: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: false, items: [], total: 0, allList: [], stats: { inTransit: 0, lateDepart: 0, lateArrive: 0 },
      query: createListQuery(), appliedQuery: createListQuery(), sortField: 'createTime', sortOrder: 'descending', page: 1, pageSize: 15, selected: [], selectedRow: {}, requestId: 0,
      preferenceKey: '', preferences: { hideCanceled: false, hideMapVehicles: false },
      cancelVisible: false, cancelTarget: null, cancelReason: '', canceling: false,
      importVisible: false, importing: false, exporting: false, importFile: null, importFileList: [], importResult: null,
      recordsVisible: false, recordsType: 'IMPORT', addressVisible: false, accountShareVisible: false,
      shareVisible: false, sharing: false, shareScope: 'CURRENT_POSITION', shareHours: 24, shareLink: '', shareId: '',
      textFilters: [{ key: 'waybillNo', label: '运单号' }, { key: 'vehicleNo', label: '车牌号' }, { key: 'driverName', label: '司机' }, { key: 'startAddress', label: '起始地' }, { key: 'endAddress', label: '目的地' }, { key: 'cargoName', label: '货物' }],
      statuses: defaultBusinessOptions('waybill_status'),
      alarmOptions: [{ value: 1, label: '晚发' }, { value: 2, label: '晚到' }, { value: 3, label: '线路偏离' }, { value: 4, label: '超时停车' }, { value: 5, label: '在途离线' }],
      timeFields: [{ value: 'createTime', label: '创建时间' }, { value: 'planDepartTime', label: '计划出发时间' }, { value: 'planArriveTime', label: '计划到达时间' }, { value: 'startFenceTime', label: '起始地触碰围栏' }, { value: 'endFenceTime', label: '目的地触碰围栏' }],
      dateColumns: [{ key: 'planDepartTime', label: '计划出发', sortable: true }, { key: 'planArriveTime', label: '计划到达', sortable: true }, { key: 'actualDepartTime', label: '实际出发', sortable: true }, { key: 'actualArriveTime', label: '实际到达', sortable: true }, { key: 'startFenceTime', label: '进入起点围栏' }, { key: 'startDepartFenceTime', label: '驶出起点围栏' }, { key: 'endFenceTime', label: '进入目的地围栏' }, { key: 'endDepartFenceTime', label: '驶出目的地围栏' }]
    }
  },
  computed: {
    canAction() { return this.actionScopes.includes('waybill:action') },
    hasInactiveStatus() { return this.query.status !== '' && this.query.status != null && !this.statuses.some(item => item.value === Number(this.query.status)) }
  },
  async created() {
    const restored = !this.embedMode && parseListState(this.$route.query.listState)
    if (restored) {
      this.query = cloneQuery(restored.query)
      this.appliedQuery = cloneQuery(restored.query)
      this.page = restored.page
      this.pageSize = restored.pageSize
      this.sortField = restored.sortField
      this.sortOrder = restored.sortOrder
    }
    if (!this.embedMode) {
      this.loadWaybillStatuses()
      try {
        const preferences = await loadWaybillPreferences()
        this.preferenceKey = preferences.key
        this.preferences = preferences.value
        if (!restored) this.query.hideCanceled = this.appliedQuery.hideCanceled = preferences.value.hideCanceled
      } catch (error) { this.$message.warning('账号偏好加载失败，使用默认设置') }
    }
    this.fetchList()
  },
  beforeDestroy() { this.requestId += 1 },
  methods: {
    async loadWaybillStatuses() {
      try { this.statuses = await loadBusinessOptions('waybill_status') }
      catch (error) { this.$message.warning('运单状态字典加载失败，使用默认选项') }
    },
    listParams() { return buildListParams(this.appliedQuery, { page: this.page, pageSize: this.pageSize, sortField: this.sortField, sortOrder: this.sortOrder }) },
    returnState() { return JSON.stringify({ query: this.appliedQuery, page: this.page, pageSize: this.pageSize, sortField: this.sortField, sortOrder: this.sortOrder }) },
    async fetchList() {
      const id = ++this.requestId
      this.loading = true
      try {
        if (this.embedMode) {
          const res = await getWaybillList()
          if (id !== this.requestId) return
          if (!isRequestSuccess(res)) throw new Error(res.msg || '获取运单失败')
          this.allList = res.data || []
          const filtered = filterEmbedWaybills(this.allList, this.appliedQuery, this.sortField, this.sortOrder)
          this.total = filtered.length
          this.items = filtered.slice((this.page - 1) * this.pageSize, this.page * this.pageSize)
          this.stats = { inTransit: filtered.filter(row => Number(row.transportStatus) === 1).length }
        } else {
          const res = await queryWaybillList(this.listParams())
          if (id !== this.requestId) return
          if (!isRequestSuccess(res)) throw new Error(res.msg || '获取运单失败')
          const data = res.data || {}
          this.items = data.items || []
          this.total = Number(data.total || 0)
          this.stats = data.stats || { inTransit: 0, lateDepart: 0, lateArrive: 0 }
        }
        this.clearSelection()
        if (this.page > 1 && !this.items.length && this.total) { this.page = Math.ceil(this.total / this.pageSize); this.fetchList() }
      } catch (error) {
        if (id === this.requestId) this.$message.error(error.msg || error.message || '获取运单失败，请刷新重试')
      } finally { if (id === this.requestId) this.loading = false }
    },
    search() {
      const range = this.query.timeRange || []
      if (range.length === 2 && Number(range[0]) > Number(range[1])) return this.$message.warning('开始时间不能晚于结束时间')
      this.appliedQuery = cloneQuery(this.query)
      this.page = 1
      this.fetchList()
    },
    reset() {
      this.query = { ...createListQuery(), timeRange: [], hideCanceled: this.preferences.hideCanceled }
    },
    handleSortChange({ prop, order }) {
      this.sortField = order ? prop : 'createTime'
      this.sortOrder = order || 'descending'
      this.page = 1
      this.fetchList()
    },
    changePageSize(size) { this.pageSize = size; this.page = 1; this.fetchList() },
    changePage(page) { this.page = page; this.fetchList() },
    clearSelection() { this.selected = []; if (this.$refs.waybillTable) this.$refs.waybillTable.clearSelection() },
    async savePreferences() {
      try {
        saveWaybillPreferences(this.preferenceKey, this.preferences)
        this.query.hideCanceled = this.appliedQuery.hideCanceled = this.preferences.hideCanceled
        this.page = 1
        this.fetchList()
      } catch (error) { this.$message.error(error.message || '设置保存失败') }
    },
    oneSelected() {
      if (this.selected.length !== 1) { this.$message.warning('请选择一条运单'); return null }
      return this.selected[0]
    },
    goCreate() { this.$router.push({ name: 'LingDongWaybillCreateName' }) },
    selectedAction(command) { const row = this.oneSelected(); if (row) this.handleCommand(command, row) },
    changeAddress() {
      const row = this.oneSelected()
      if (!row) return
      if (![0, 1].includes(Number(row.transportStatus)) || row.actualArriveTime) return this.$message.warning('仅待开始或未到达目的地的运输中运单可以更换地址')
      this.selectedRow = row
      this.addressVisible = true
    },
    planSelectedRoute() {
      const row = this.oneSelected()
      if (!row) return
      if (Number(row.transportStatus) === 0) { this.edit(row, true); return }
      if (row.routeId) { this.$router.push({ name: 'LingDongRouteViewName', params: { id: row.routeId } }); return }
      this.$message.warning('请在待开始时规划并绑定路线，运输中可通过更换地址调整目的地')
    },
    mergeTracks() {
      if (this.selected.length !== 2) return this.$message.warning('请选择2条运单')
      const [first, second] = this.selected
      if (String(first.vehicleNo || '').replace(/\s/g, '').toUpperCase() !== String(second.vehicleNo || '').replace(/\s/g, '').toUpperCase() || String(first.plateColor) !== String(second.plateColor)) return this.$message.warning('请选择同一辆车、同一车牌颜色的两条运单')
      if (this.selected.some(row => [0, 3].includes(Number(row.transportStatus)))) return this.$message.warning('待开始或已作废的运单不支持查看轨迹')
      if (this.embedMode) return this.$message.warning('嵌入模式暂不支持双单联合回放，请在完整系统中操作')
      this.$router.push({ name: 'LingDongWaybillMapName', params: { transportNo: first.waybillNo }, query: { transportNo2: second.waybillNo, returnQuery: this.returnState(), view: 'track' } })
    },
    openMap(row, view) {
      if (this.embedMode) return this.openDetail(row)
      if (!hasPermission(['waybill:monitor', 'fullmap:view'])) return this.$message.warning('当前账号没有查看运单地图的权限')
      this.$router.push({ name: 'LingDongWaybillMapName', params: { transportNo: row.waybillNo }, query: { view, returnQuery: this.returnState() } })
    },
    openDetail(row) {
      if (this.embedMode) {
        this.$emit('waybill-selected', { waybillNo: row.waybillNo })
        this.$emit('open-waybill', row.waybillNo)
        return
      }
      this.openMap(row, 'detail')
    },
    edit(row, routePlanning = false) {
      if (Number(row.transportStatus) !== 0) return
      this.$router.push({ name: 'LingDongWaybillEditName', params: { transportNo: row.waybillNo }, query: { routePlanning: routePlanning ? '1' : undefined, listState: this.returnState() } })
    },
    async handleCommand(command, row) {
      if (command === 'detail') return this.openDetail(row)
      if (command === 'edit') return this.edit(row)
      if (command === 'delete') return this.delete(row)
      if (command === 'cancel') return this.cancel(row)
      if (this.embedMode && !this.canAction) return this.$message.warning('当前组件没有操作权限')
      const targetStatus = command === 'start' ? 1 : 2
      if ((targetStatus === 1 && Number(row.transportStatus) !== 0) || (targetStatus === 2 && ![1, 4].includes(Number(row.transportStatus)))) return this.$message.warning('当前运单状态不支持此操作')
      const label = targetStatus === 1 ? '开始运输' : '完成运输'
      try {
        await this.$confirm('确认' + label + '运单「' + row.waybillNo + '」吗？', '提示', { type: 'warning' })
        const res = await changeWaybillStatus({ transportNo: row.waybillNo, status: targetStatus })
        if (!isRequestSuccess(res)) throw new Error(res.msg || '操作失败')
        this.$message.success(label + '成功')
        if (this.embedMode) this.$emit('action-completed', { action: targetStatus === 1 ? 'start' : 'stop', waybillNo: row.waybillNo })
        this.fetchList()
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.msg || error.message || '操作失败') }
    },
    async delete(row) {
      if (Number(row.transportStatus) !== 0 || this.embedMode) return
      try {
        await this.$confirm('确认删除待开始运单「' + row.waybillNo + '」吗？删除后不可恢复。', '提示', { type: 'warning' })
        const res = await deleteWaybill(row.waybillNo)
        if (!isRequestSuccess(res)) throw new Error(res.msg || '删除失败')
        this.$message.success('运单已删除')
        this.fetchList()
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.msg || error.message || '删除失败') }
    },
    cancel(row) {
      if (this.embedMode || this.canceling) return
      if (![0, 1].includes(Number(row.transportStatus))) return this.$message.warning('仅待开始或运输中的运单允许作废')
      this.cancelTarget = row
      this.cancelReason = ''
      this.cancelVisible = true
    },
    async submitCancel() {
      if (this.canceling || !this.cancelTarget) return
      const reason = this.cancelReason.trim()
      if (reason.length > 256) return this.$message.warning('作废原因不能超过256字')
      this.canceling = true
      try {
        const res = await cancelWaybill({ transportNo: this.cancelTarget.waybillNo, cancelReason: reason })
        if (!isRequestSuccess(res)) throw new Error(res.msg || '作废失败')
        this.$message.success('运单已作废')
        this.cancelVisible = false
        this.fetchList()
      } catch (error) {
        this.$message.error(error.msg || error.message || '作废失败')
      } finally {
        this.canceling = false
      }
    },
    showRecords(type) { this.recordsType = type; this.recordsVisible = true },
    onImportFileChange(file, list) { this.importFile = file.raw; this.importFileList = list.slice(-1); this.importResult = null },
    onImportFileExceed() { this.$message.warning('一次只能选择一个文件') },
    resetImport() { this.importFile = null; this.importFileList = []; this.importResult = null },
    async submitImport() {
      if (!this.importFile) return this.$message.warning('请先选择导入文件')
      if (this.importing) return
      this.importing = true
      try {
        const res = await importWaybills(this.importFile)
        if (!isRequestSuccess(res)) throw new Error(res.msg || '导入失败')
        this.importResult = res.data || {}
        this.$message[Number(this.importResult.failureCount) ? 'warning' : 'success']('导入已完成，可查看处理结果及导入记录')
        this.fetchList()
      } catch (error) { this.$message.error(error.msg || error.message || '导入失败，可在导入记录查看结果') } finally { this.importing = false }
    },
    async downloadImportTemplate() {
      try { await downloadWaybillBlob(await downloadWaybillImportTemplate(), '运单导入模板.xlsx') } catch (error) { this.$message.error(error.msg || error.message || '模板下载失败') }
    },
    async exportList() {
      this.exporting = true
      try { await downloadWaybillBlob(await exportWaybillList(this.listParams()), '运单导出.xlsx'); this.$message.success('导出完成，可在导出记录再次下载') } catch (error) { this.$message.error(error.msg || error.message || '导出失败') } finally { this.exporting = false }
    },
    openShare(row) { this.selectedRow = row; this.shareLink = ''; this.shareId = ''; this.shareScope = 'CURRENT_POSITION'; this.shareHours = 24; this.shareVisible = true },
    async createShareLink() {
      this.sharing = true
      try {
        const res = await createWaybillShare({ transportNo: this.selectedRow.waybillNo, scope: this.shareScope, expiresInHours: this.shareHours })
        if (!isRequestSuccess(res) || !res.data.shareId) throw new Error(res.msg || '生成分享链接失败')
        this.shareId = res.data.shareId
        this.shareLink = new URL(this.$router.resolve({ name: 'LingDongWaybillShareMapName', params: { shareId: this.shareId } }).href, window.location.href).href
      } catch (error) { this.$message.error(error.msg || error.message || '生成分享链接失败') } finally { this.sharing = false }
    },
    async copyShareLink() {
      try { await navigator.clipboard.writeText(this.shareLink); this.$message.success('链接已复制') } catch (error) { this.$message.warning('请选中上方链接并复制') }
    },
    async revokeShareLink() {
      this.sharing = true
      try {
        const res = await revokeWaybillShare({ shareId: this.shareId })
        if (!isRequestSuccess(res)) throw new Error(res.msg || '撤销失败')
        this.shareLink = ''
        this.shareId = ''
        this.$message.success('链接已撤销')
      } catch (error) { this.$message.error(error.msg || error.message || '撤销失败') } finally { this.sharing = false }
    },
    statusText(status) { return businessOptionLabel('waybill_status', this.statuses, status) },
    statusTag(status) { return { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger', 4: 'info' }[Number(status)] || 'info' },
    alarmText(row) { return (row.alarmTypes || []).map(type => { const item = this.alarmOptions.find(item => item.value === Number(type)); return item ? item.label : '' }).filter(Boolean).join('、') || '-' },
    monitorText(row) {
      if (Number(row.transportStatus) === 4) return '监控超期'
      if ([2, 3].includes(Number(row.transportStatus))) return '已停止'
      if (Number(row.transportStatus) === 0) return '待启动'
      return { ONLINE: '监控中', NO_TRACK: '无轨迹', OFFLINE: '离线' }[row.monitorStatus] || '无轨迹'
    },
    progress(row) {
      if (Number(row.transportStatus) === 2) return 100
      if (row.progress === null || row.progress === undefined || row.progress === '') return null
      const progress = Number(row.progress)
      return Number.isFinite(progress) ? Math.max(0, Math.min(99, Math.round(progress))) : null
    },
    formatDate(value) { return value && dayjs(value).isValid() ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-' },
    formatDistance(value) { return value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) ? Number(value).toFixed(2).replace(/\.00$/, '') + ' km' : '-' },
    applyEmbedCommand(command, payload = {}) {
      if (command === 'refresh') this.fetchList()
      if (command === 'setFilter' || command === 'filter') {
        if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return
        if (payload.vehicleNo !== undefined) this.query.vehicleNo = payload.vehicleNo
        if (payload.waybillNo !== undefined) this.query.waybillNo = payload.waybillNo
        if (payload.transportStatus !== undefined) this.query.status = payload.transportStatus
        this.search()
      }
    }
  }
}
</script>

<style scoped>
.waybill-list-page { min-height: 100%; padding: 16px 18px 22px; box-sizing: border-box; background: #f4f6f9; }
.filter-card, .list-card { border: 1px solid #e6ebf2; border-radius: 4px; background: #fff; }
.filter-card { padding: 16px 16px 2px; }
.filter-form { display: grid; grid-template-columns: repeat(6, minmax(130px, 1fr)); gap: 0 16px; align-items: center; }
.filter-form ::v-deep .el-form-item { display: flex; margin-bottom: 14px; min-width: 0; }
.filter-form ::v-deep .el-form-item__label { flex-shrink: 0; padding-right: 8px; color: #606266; font-size: 12px; }
.filter-form ::v-deep .el-form-item__content { flex: 1; min-width: 0; margin-left: 0 !important; }
.filter-form ::v-deep .el-input__inner { font-size: 12px; }
.filter-form ::v-deep .el-select { width: 100%; }
.filter-form__time { grid-column: span 3; }
.filter-time-range { display: flex; gap: 8px; min-width: 0; width: 100%; }
.filter-time-range__type { flex: 0 0 150px; }
.filter-time-range ::v-deep .el-range-editor { flex: 1; width: 0; min-width: 220px; padding-right: 4px; }
.filter-time-range ::v-deep .el-range-input { font-size: 11px; width: 46%; }
.filter-time-range ::v-deep .el-range-separator { width: 6%; padding: 0; }
.filter-actions { display: flex; align-items: center; margin-bottom: 14px; }
.list-card { margin-top: 12px; padding: 14px 16px 16px; }
.list-toolbar { display: flex; justify-content: space-between; gap: 12px; align-items: flex-start; }
.list-toolbar__left { display: flex; flex-wrap: wrap; gap: 8px; }
.list-toolbar ::v-deep .el-button { margin: 0; padding: 8px 10px; font-size: 12px; }
.list-toolbar__right { display: flex; flex-shrink: 0; gap: 8px; }
.list-summary { display: flex; align-items: center; gap: 26px; min-height: 44px; color: #606266; font-size: 12px; }
.list-summary strong { color: #1677ff; margin: 0 4px; font-size: 15px; font-weight: 500; }
.list-summary .summary-warning { color: #e6a23c; }.list-summary .summary-danger { color: #f56c6c; }
.summary-total { margin-left: auto; color: #909399; }.selection-summary { color: #409eff; }.selection-summary .el-button { margin-left: 8px; }
.waybill-table { width: 100%; }
.waybill-table ::v-deep th { height: 38px; padding: 5px 0; background: #f5f7fa; color: #606266; font-weight: 500; }
.waybill-table ::v-deep td { height: 42px; padding: 5px 0; color: #303133; }
.waybill-table ::v-deep .el-button--text { margin: 0 6px 0 0; padding: 4px 0; font-size: 12px; }
.waybill-table ::v-deep .el-table__fixed { box-shadow: 5px 0 7px -5px rgba(31,45,61,.2); }
.waybill-table ::v-deep .waybill-actions .cell { display: flex; align-items: center; justify-content: center; padding: 0 6px; white-space: nowrap; }
.waybill-table ::v-deep .el-table-column--selection .cell { padding: 0 8px; text-overflow: clip; }
.more-action { color: #409eff; font-size: 12px; cursor: pointer; }.more-action i { margin-left: 3px; font-size: 10px; }
.progress-value { display: block; line-height: 16px; color: #909399; font-size: 11px; }.alarm-text { color: #e6a23c; }
.pagination-wrap { display: flex; justify-content: flex-end; padding-top: 16px; }
.list-settings { display: flex; flex-direction: column; gap: 18px; padding: 8px; }.list-settings strong { color: #303133; font-size: 13px; }.list-settings .el-checkbox { margin: 0; }
.waybill-import-result { margin-top: 14px; }.waybill-import-errors { max-height: 180px; padding: 10px; margin-top: 10px; overflow: auto; background: #fdf6ec; color: #b45309; font-size: 12px; line-height: 22px; }
@media (max-width: 1300px) { .filter-form { grid-template-columns: repeat(3, minmax(180px, 1fr)); }.filter-form__time { grid-column: span 2; }.filter-time-range__type { flex-basis: 138px; } }
@media (max-width: 800px) { .waybill-list-page { padding: 10px; }.filter-form { grid-template-columns: repeat(2, minmax(130px, 1fr)); }.filter-form__time { grid-column: span 2; }.list-card { padding: 10px; }.list-summary { flex-wrap: wrap; gap: 12px; padding: 10px 0; }.pagination-wrap { overflow-x: auto; }.filter-time-range__type { flex-basis: 125px; } }
</style>
